import { useQuery, type UseQueryResult } from "@tanstack/react-query"

import { api } from "@/api/instance"
import { qk } from "@/shared/api/queryKeys";

interface ServiceFlags {
    copilot: boolean
    dashboard: boolean
    llm_analytics: boolean
    visit_card: boolean
    checkpoints: boolean
    feedback_form: boolean
}

const DEFAULT_SERVICE_FLAGS: ServiceFlags = {
    copilot: false,
    dashboard: false,
    llm_analytics: false,
    visit_card: false,
    checkpoints: false,
    feedback_form: false,
}

export function useFeaturesQuery(): UseQueryResult<ServiceFlags> {
    return useQuery({
        queryKey: qk.features.all(),
        queryFn: async () => {
            const res = await api.instance.get<Partial<ServiceFlags>>("/v1/features")
            return { ...DEFAULT_SERVICE_FLAGS, ...res.data }
        },
        staleTime: 60_000,
    })
}

export function useServiceFlags(): ServiceFlags {
    return useFeaturesQuery().data ?? DEFAULT_SERVICE_FLAGS
}
